import { render } from "./listVinksRegionsFuel.vue?vue&type=template&id=46e0ea82&scoped=true"
import script from "./listVinksRegionsFuel.vue?vue&type=script&lang=js"
export * from "./listVinksRegionsFuel.vue?vue&type=script&lang=js"

import "./listVinksRegionsFuel.vue?vue&type=style&index=0&id=46e0ea82&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e0ea82"]])

export default __exports__